<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useMasses from "../../use/useMasses"

const props = defineProps({
  mass: {
    required: true,
    type: Object,
  },
})

const massData = ref({
  id: props.mass.id,
  text: props.mass.text,
  date: props.mass.date,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, closeModal } = useMasses(props, emit, massData)

onUpdated(() => {
  massData.value = {
    id: props.mass.id,
    text: props.mass.text,
    date: props.mass.date,
  }
})
</script>

<template>
  <!-- view mass modal  -->
  <BModal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="اطلاعات آیین قربانی"
    class="v-modal-custom"
    scrollable
    no-close-on-backdrop
    size="lg"
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <h6 class="fs-15">
        <i class="ri-checkbox-circle-fill text-success"></i>
        <strong class="mx-1">تاریخ نمایش آیین قربانی: </strong> {{ massData.date }}
      </h6>

      <h6 class="fs-15 mt-3">
        <i class="ri-checkbox-circle-fill text-success"></i>
        <strong class="mx-1">متن آیین قربانی: </strong>
      </h6>
      <div class="py-2 px-3" v-html="massData.text"></div>
    </b-overlay>
    <div class="modal-footer v-modal-footer">
      <BButton type="button" variant="light" @click="closeModal">بستن </BButton>
    </div>
  </BModal>
</template>
